// SignalMonitor — Live signal feed (Angel One light theme)
import React from 'react';
import { FaBolt } from 'react-icons/fa';

export default function SignalMonitor({ signals }) {
  if (!signals || signals.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 text-center">
        <FaBolt className="text-2xl text-gray-300 mx-auto mb-2" />
        <p className="text-xs text-gray-400">No signals yet. Start the algo engine to generate signals.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {signals.map((signal, i) => {
        const isBuy = signal.action === 'BUY' || signal.action === 'EXIT_SHORT';
        return (
          <div
            key={i}
            className={`bg-white border border-gray-200 rounded-lg shadow-sm p-3 border-l-2 ${
              isBuy ? 'border-l-green-500' : 'border-l-red-500'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <FaBolt className={`text-[10px] ${isBuy ? 'text-green-600' : 'text-red-500'}`} />
                <span className={`text-xs font-bold ${isBuy ? 'text-green-600' : 'text-red-500'}`}>
                  {signal.action}
                </span>
                <span className="text-xs font-semibold text-gray-900">{signal.instrument?.symbol}</span>
              </div>
              <span className="text-[10px] text-gray-400">{signal.timestamp?.split('T')[1]?.slice(0, 8)}</span>
            </div>
            <p className="text-[11px] text-gray-500 mt-1">Strategy: {signal.strategyName}</p>
          </div>
        );
      })}
    </div>
  );
}
